import { render } from "./ManageReviews.vue?vue&type=template&id=dc07ce4e"
import script from "./ManageReviews.vue?vue&type=script&lang=js"
export * from "./ManageReviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__